import React from "react";
import { useSession } from "@/session";
import { canAccessBusinesses } from "@/screens/screen-tenants-access";
import { LiveUpdatesProvider } from "./live-provider";

/**
 * Binds the live streams to the current session (#544). Kept apart from the provider so the
 * provider itself stays session-free and can be rendered directly in tests.
 */
export function LiveUpdatesGate({ children }: { children: React.ReactNode }) {
  const { user } = useSession();
  return (
    <LiveUpdatesProvider
      userId={user?.id ?? null}
      tenantId={user?.tenantId ?? null}
      owner={!!user && canAccessBusinesses(user.role)}
    >
      {children}
    </LiveUpdatesProvider>
  );
}
